import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ModalController} from '@ionic/angular';
import {
    BaseStepperFormComponent,
    LoadingService,
    MembershipTokenGroup,
    MembershipTokenGroupService,
    MenuItemPriceSummary,
    Organization,
    ToastService
} from 'brewbill-lib';

@Component({
    selector: 'bb-edit-membership-token-group',
    templateUrl: './edit-membership-token-group.component.html',
    styleUrls: ['./edit-membership-token-group.component.scss'],
})
export class EditMembershipTokenGroupComponent extends BaseStepperFormComponent implements OnInit {
    @Input() organization: Organization;
    @Input() tokenGroup: MembershipTokenGroup;
    formGroup: FormGroup;
    partial = true;

    priceSummaries: MenuItemPriceSummary[];
    itemFilter = '';
    filteredItems = [];

    constructor(
        modalController: ModalController,
        private membershipTokenGroupService: MembershipTokenGroupService,
        private loadingService: LoadingService,
        private toastService: ToastService,
        private formBuilder: FormBuilder
    ) {
        super(modalController);
    }

    ngOnInit() {
        const roles = [];
        this.formGroup = this.formBuilder.group({
            id: !!this.tokenGroup ? this.tokenGroup.id : null,
            parentId: this.organization.id,
            name: [
                !!this.tokenGroup ? this.tokenGroup.name : '',
                Validators.required
            ],
            description: !!this.tokenGroup ? this.tokenGroup.description : '',
            tokenCount: [!!this.tokenGroup ? this.tokenGroup.tokenCount : '', Validators.required],
            limitDurationPart: !!this.tokenGroup ? this.tokenGroup.limitDurationPart : 'NONE',
            limitDurationCount: !!this.tokenGroup ? this.tokenGroup.limitDurationCount : '',
            limitCount: !!this.tokenGroup ? this.tokenGroup.limitCount : '',
        });

        this.priceSummaries = this.priceSummaries.map(item => {
            const container = new MenuItemPriceSummary({...item});
            container.qualified = !!this.tokenGroup && !!this.tokenGroup.items
                && this.tokenGroup.items.some(q => q.itemId === item.itemId && q.priceId === item.priceId);

            return container;
        });
        this.filteredItems = [...this.priceSummaries];
    }

    filterItems(items: any[], filter: string) {
        const lower = !!filter ? filter.toLowerCase() : '';
        return !!filter && !!items ? items.filter((p: any) =>
                (!!p.itemName && p.itemName.toLowerCase().includes(lower))
                || (!!p.priceName && p.priceName.toLowerCase().includes(lower)))
            : items;
    }

    onSubmit() {
        if (this.formGroup.valid) {
            const tokenGroup = new MembershipTokenGroup(this.formGroup.value);

            tokenGroup.items = this.priceSummaries.filter(item => item.qualified);

            this.loadingService.present();
            if (!tokenGroup.id) {
                this.membershipTokenGroupService.create(tokenGroup).subscribe(c => {
                    this.loadingService.dismiss();
                    this.close(new MembershipTokenGroup(c));
                });
            } else {
                this.membershipTokenGroupService.update(tokenGroup).subscribe(c => {
                    this.loadingService.dismiss();
                    this.close(new MembershipTokenGroup(c));
                });
            }
        }
    }

    durationChanged() {
        if (this.formGroup.get('limitDurationPart').value === 'NONE') {
            this.formGroup.get('limitDurationCount').setValue(null);
            this.formGroup.get('limitDurationCount').setValidators([]);
            this.formGroup.get('limitCount').setValue(null);
            this.formGroup.get('limitCount').setValidators([]);
        } else {
            if (!this.formGroup.get('limitCount').value) {
                this.formGroup.get('limitCount').setValue(1);
            }

            if (!this.formGroup.get('limitDurationCount').value) {
                this.formGroup.get('limitDurationCount').setValue(1);
            }

            this.formGroup.get('limitCount').setValidators([Validators.required, Validators.min(1)]);

            if (this.formGroup.get('limitDurationPart').value === 'TAB') {
                this.formGroup.get('limitDurationCount').setValue(null);
                this.formGroup.get('limitDurationCount').setValidators([]);
            } else {
                this.formGroup.get('limitDurationCount').setValidators([Validators.required, Validators.min(1)]);
            }
        }

        this.formGroup.get('limitCount').updateValueAndValidity();
        this.formGroup.get('limitDurationPart').updateValueAndValidity();
        this.formGroup.get('limitDurationCount').updateValueAndValidity();
    }
}
